import { styled } from 'styled-components';

export const ImagePickerLoadingHolder = styled.div<{
  $previewWidth?: number;
}>`
  height: 100px;
  width: ${(props) => props.$previewWidth ?? 96}px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 32px;
  }
`;
